import { render, staticRenderFns } from "./Kib.vue?vue&type=template&id=c27516fc&"
import script from "./Kib.vue?vue&type=script&lang=js&"
export * from "./Kib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports